(function () {
	if (window.__krownProductQtyLimitsReady) return;
	window.__krownProductQtyLimitsReady = true;

	const LIMITS = {
		'9494635053359': {
			max: 20,
			message: 'You can only add up to 20 of this item to your cart.',
		},
	};

	window.__KROWN_PRODUCT_QTY_LIMITS = LIMITS;

	window.__krownGetProductQtyLimit = function (productId) {
		if (!productId) return null;
		const entry = LIMITS[String(productId)];
		const limit = typeof entry === 'object' ? entry.max : entry;
		return Number.isFinite(limit) ? limit : null;
	};

	window.__krownGetProductQtyLimitMessage = function (productId) {
		const entry = LIMITS[String(productId)];
		if (entry == null) return '';
		if (typeof entry === 'object' && entry.message) {
			return entry.message;
		}
		const limit = window.__krownGetProductQtyLimit(productId);
		return limit == null ? '' : `You can only add up to ${limit} of this item to your cart.`;
	};

	window.__krownGetCapTotal = function (ruleMax, stockLimit) {
		const limits = [];
		if (ruleMax != null && ruleMax !== '') {
			const r = parseInt(ruleMax, 10);
			if (Number.isFinite(r) && r >= 0) limits.push(r);
		}
		if (stockLimit != null && stockLimit !== '') {
			const s = parseInt(stockLimit, 10);
			if (Number.isFinite(s) && s >= 0) limits.push(s);
		}
		if (limits.length === 0) return null;
		return Math.min(...limits);
	};

	window.__krownGetAvailabilityMessageCount = function (context) {
		if (context == null) return 0;
		if (typeof context === 'number') {
			const qty = parseInt(context, 10);
			return Number.isFinite(qty) && qty >= 0 ? qty : 0;
		}
		const ruleMax = context.ruleMax ?? context.quantityRuleMax;
		const stockLimit = context.stockLimit ?? context.inventoryQuantity ?? context.inventoryQty;
		const capTotal = window.__krownGetCapTotal(ruleMax, stockLimit);
		if (capTotal != null) return capTotal;
		return 0;
	};

	window.__krownGetAvailabilityAddedMessage = function (contextOrQty) {
		const context =
			typeof contextOrQty === 'object' && contextOrQty !== null
				? contextOrQty
				: typeof contextOrQty === 'number'
					? { stockLimit: contextOrQty }
					: {};
		const qty = window.__krownGetAvailabilityMessageCount(context);
		if (!Number.isFinite(qty) || qty < 0) return '';
		const template =
			(typeof KROWN !== 'undefined' && KROWN.settings?.locales?.products_availability_partial_add) ||
			'Only {{ count }} items were added to your cart due to availability.';
		return template.replace(/\{\{\s*count\s*\}\}/g, String(qty));
	};

	/** PDP + cart at-cap / over-limit (non-GC). Product cards keep "were added". */
	window.__krownGetAvailabilityCanAddMessage = function (contextOrQty) {
		const context =
			typeof contextOrQty === 'object' && contextOrQty !== null
				? contextOrQty
				: typeof contextOrQty === 'number'
					? { stockLimit: contextOrQty }
					: {};
		const qty = window.__krownGetAvailabilityMessageCount(context);
		if (!Number.isFinite(qty) || qty < 0) return '';
		const template =
			(typeof KROWN !== 'undefined' && KROWN.settings?.locales?.products_availability_can_add) ||
			'Only {{ count }} can be added to your cart due to availability.';
		return template.replace(/\{\{\s*count\s*\}\}/g, String(qty));
	};

	window.__krownGetCartAtCapMessage = function (contextOrStockLimit) {
		const context =
			typeof contextOrStockLimit === 'object' && contextOrStockLimit !== null
				? contextOrStockLimit
				: { stockLimit: contextOrStockLimit };
		return window.__krownGetAvailabilityCanAddMessage(context);
	};

	window.__krownResolveStockMessage = function (scenario, context) {
		context = context || {};
		const capContext = {
			ruleMax: context.ruleMax ?? context.quantityRuleMax,
			stockLimit: context.stockLimit ?? context.inventoryQuantity ?? context.inventoryQty,
		};
		const forProductCard =
			context.isProductCard === true ||
			scenario === 'product_card_at_cap' ||
			scenario === 'product_card';
		// Product cards keep "were added"; PDP/cart use "can be added"
		if (forProductCard) {
			return window.__krownGetAvailabilityAddedMessage(capContext);
		}
		if (scenario === 'partial_add' || scenario === 'cart_at_cap') {
			return window.__krownGetCartAtCapMessage(capContext);
		}
		return window.__krownGetAvailabilityCanAddMessage(capContext);
	};

	window.__krownIsProductCardContext = function (el) {
		return !!(
			el?.closest?.('[data-js-product-item]') ||
			el?.matches?.('quick-add-to-cart') ||
			el?.closest?.('quick-add-to-cart')
		);
	};

	/**
	 * Qty-rule max only — never the live input `max` (often remaining-to-add, can be 0).
	 * Prefer data-krown-rule-max / data-rs-rule-max; do not treat inventory remaining as a rule.
	 */
	window.__krownGetRuleMax = function (qtyInput) {
		if (!qtyInput) return null;
		const attr =
			qtyInput.getAttribute?.('data-krown-rule-max') ||
			qtyInput.getAttribute?.('data-rs-rule-max');
		if (attr == null || attr === '') return null;
		const parsed = parseInt(attr, 10);
		return Number.isFinite(parsed) ? parsed : null;
	};

	/**
	 * Cap total for messaging: min(ruleMax, stockLimit) — NOT remaining-to-add.
	 * Used by cart + PDP "Only {X} can be added…" copy.
	 */
	window.__krownGetCartLineCapContext = function (form, item) {
		const productId = item?.dataset?.productId || null;
		const hardLimit = window.__krownGetProductQtyLimit(productId);
		const qtyInput = item?.querySelector?.('.qty, .qty-selector');
		const ruleMax = window.__krownGetRuleMax(qtyInput) ?? hardLimit;
		const stockLimit = window.__krownIsGiftCardCartItem(item)
			? null
			: window.__krownGetVariantInventoryFromCartItem(item);
		const capTotal = window.__krownGetCapTotal(ruleMax, stockLimit);
		const maxForLine =
			typeof window.__krownGetMaxQtyForCartLine === 'function'
				? window.__krownGetMaxQtyForCartLine(form, item)
				: null;
		return {
			productId,
			ruleMax,
			stockLimit,
			capTotal,
			maxForLine,
			isGiftCard: window.__krownIsGiftCardCartItem(item),
		};
	};

	window.__krownGetProductPageCapContext = function (productPage, productId, qtyInput) {
		const hardLimit = window.__krownGetProductQtyLimit(productId);
		const ruleMax = window.__krownGetRuleMax(qtyInput) ?? hardLimit;
		const stockLimit = window.__krownIsGiftCardProductPage(productPage)
			? null
			: window.__krownGetAvailabilityStockLimit(productPage);
		const capTotal = window.__krownGetCapTotal(ruleMax, stockLimit);
		return {
			productId,
			ruleMax,
			stockLimit,
			capTotal,
			isGiftCard: window.__krownIsGiftCardProductPage(productPage),
		};
	};

	window.__krownClearCartFormQtyLimitBanners = function (root) {
		const cartForm =
			root?.closest?.('cart-form') ||
			(root?.matches?.('cart-form') ? root : null) ||
			root?.querySelector?.('cart-form');
		const form =
			root?.matches?.('form') ? root : root?.querySelector?.('form') || cartForm?.querySelector?.('form');
		const scopes = [cartForm, form].filter(Boolean);
		scopes.forEach((scope) => {
			scope.querySelectorAll('.alert--qty-limit:not(.cart-item__qty-limit-notice)').forEach((el) => {
				el.remove();
			});
		});
	};

	window.__krownGetZeroAddableMessage = async function (productPage, productId, variantId) {
		const isGiftCard = window.__krownIsGiftCardProductPage(productPage);
		const qtyInput =
			productPage?.querySelector?.('input[name="quantity"]') ||
			productPage?.querySelector?.('.qty-selector');
		const hardLimit = window.__krownGetProductQtyLimit(productId);
		const capCtx = window.__krownGetProductPageCapContext?.(productPage, productId, qtyInput) || {};
		const stockLimit = capCtx.stockLimit;
		const ruleMax = capCtx.ruleMax ?? hardLimit;
		const isProductCard = window.__krownIsProductCardContext(productPage);

		if (isGiftCard && hardLimit != null) {
			return window.__krownGetProductQtyLimitMessage(productId);
		}

		if (stockLimit != null && variantId) {
			const cartVariantQty = await window.__krownFetchCartQtyForVariant(variantId);
			if (stockLimit - cartVariantQty <= 0) {
				if (cartVariantQty > 0 || isProductCard) {
					return window.__krownResolveStockMessage('cart_at_cap', {
						ruleMax,
						stockLimit,
						isProductCard,
					});
				}
			}
		}

		if (hardLimit != null) {
			const cartProductQty = await window.__krownFetchCartQtyForProduct(productId);
			if (hardLimit - cartProductQty <= 0) {
				if (isProductCard) {
					return window.__krownResolveStockMessage('cart_at_cap', {
						ruleMax: hardLimit,
						stockLimit,
						isProductCard: true,
					});
				}
				return window.__krownGetProductQtyLimitMessage(productId);
			}
		}

		if (isProductCard) {
			return window.__krownResolveStockMessage('cart_at_cap', {
				ruleMax,
				stockLimit,
				isProductCard: true,
			});
		}

		return window.__krownGetProductQtyLimitMessage(productId);
	};

	window.__krownIsHardQtyLimitedProduct = function (productId) {
		return window.__krownGetProductQtyLimit(productId) != null;
	};

	window.__krownIsGiftCardProductPage = function (container) {
		const productPage =
			container?.closest?.('[data-js-product-component]') ||
			container?.querySelector?.('[data-js-product-component]');
		if (productPage?.hasAttribute('data-gift-card') === true) return true;
		// LIMITS map products (JP gift cards) may not set Shopify gift_card?
		const productId =
			productPage?.dataset?.id ||
			container?.dataset?.productId ||
			container?.dataset?.id ||
			container?.closest?.('[data-product-id]')?.dataset?.productId ||
			container?.querySelector?.('[data-product-id]')?.dataset?.productId;
		return window.__krownIsHardQtyLimitedProduct(productId);
	};

	window.__krownIsGiftCardCartItem = function (item) {
		if (item?.hasAttribute?.('data-gift-card') === true) return true;
		return window.__krownIsHardQtyLimitedProduct(item?.dataset?.productId);
	};

	window.__krownGetVariantInventoryFromCartItem = function (item) {
		if (!item || window.__krownIsGiftCardCartItem(item)) return null;
		const management = item.dataset.inventoryManagement;
		const policy = item.dataset.inventoryPolicy;
		if (!management || policy === 'continue') return null;
		if (typeof item.dataset.inventoryQuantity === 'undefined') return null;
		const stock = parseInt(item.dataset.inventoryQuantity, 10);
		return Number.isFinite(stock) ? Math.max(0, stock) : null;
	};

	window.__krownGetSiblingVariantQtyInForm = function (form, variantId, excludeItemKey) {
		let total = 0;
		if (!form || !variantId) return total;
		form.querySelectorAll('[data-js-cart-item]').forEach((el) => {
			if (String(el.dataset.variantId) !== String(variantId)) return;
			if (excludeItemKey && el.dataset.id === excludeItemKey) return;
			const q = parseInt(el.querySelector('.qty')?.value || el.dataset.qty, 10);
			if (Number.isFinite(q)) total += q;
		});
		return total;
	};

	window.__krownGetMaxQtyForCartLineInventory = function (form, item) {
		const stockLimit = window.__krownGetVariantInventoryFromCartItem(item);
		if (stockLimit == null) return null;
		const otherQty = window.__krownGetSiblingVariantQtyInForm(
			form,
			item?.dataset?.variantId,
			item?.dataset?.id
		);
		return Math.max(0, stockLimit - otherQty);
	};

	window.__krownGetVariantInventoryFromPage = function (productPage) {
		const el = productPage?.querySelector?.('[data-js-variant-quantity-data]');
		if (!el) return null;
		try {
			const data = JSON.parse(el.getAttribute('data-inventory') || '[]');
			return data?.[0] || null;
		} catch (_) {
			return null;
		}
	};

	window.__krownGetAvailabilityStockLimit = function (productPage) {
		if (window.__krownIsGiftCardProductPage(productPage)) return null;
		const variant = window.__krownGetVariantInventoryFromPage(productPage);
		if (!variant || variant.inventory === 'continue' || typeof variant.quantity === 'undefined') {
			return null;
		}
		const stock = parseInt(variant.quantity, 10);
		return Number.isFinite(stock) ? Math.max(0, stock) : null;
	};

	window.__krownFetchCartQtyForProduct = async function (productId) {
		if (!productId || typeof KROWN === 'undefined') return 0;
		try {
			const res = await fetch(`${KROWN.settings.routes.cart_url}.js`, {
				headers: { Accept: 'application/json' },
				cache: 'no-store',
			});
			const cart = await res.json();
			return (cart.items || []).reduce((total, item) => {
				return String(item.product_id) === String(productId) ? total + item.quantity : total;
			}, 0);
		} catch (_) {
			return 0;
		}
	};

	window.__krownFetchCartQtyForVariant = async function (variantId) {
		if (!variantId || typeof KROWN === 'undefined') return 0;
		try {
			const res = await fetch(`${KROWN.settings.routes.cart_url}.js`, {
				headers: { Accept: 'application/json' },
				cache: 'no-store',
			});
			const cart = await res.json();
			return (cart.items || []).reduce((total, item) => {
				return String(item.variant_id) === String(variantId) ? total + item.quantity : total;
			}, 0);
		} catch (_) {
			return 0;
		}
	};

	window.__krownCreateQtyLimitAlert = function (message) {
		const alert = document.createElement('div');
		alert.classList.add('alert', 'alert--error', 'alert--qty-limit');
		alert.setAttribute('role', 'alert');
		alert.textContent = message;
		return alert;
	};

	window.__krownClearProductQtyLimitAlert = function (container, itemEl) {
		const productPage =
			container?.closest?.('[data-js-product-component]') ||
			container?.querySelector?.('[data-js-product-component]');
		productPage?.querySelectorAll('[data-js-product-form-alert-host]').forEach((host) => {
			host.innerHTML = '';
		});
		container?.querySelectorAll('.alert--qty-limit').forEach((el) => el.remove());
		container
			?.closest?.('product-form')
			?.querySelectorAll('.alert--qty-limit')
			.forEach((el) => el.remove());
		document.getElementById('product-page-form-error-cart-alert')?.remove();
		itemEl?.querySelectorAll('.cart-item__qty-limit-notice').forEach((el) => el.remove());
	};

	window.__krownPlaceProductPageAlert = function (container, alertEl) {
		const productPage =
			container?.closest?.('[data-js-product-component]') ||
			container?.querySelector?.('[data-js-product-component]');
		const productForm =
			container?.closest?.('product-form') ||
			container?.querySelector?.('product-form') ||
			(productPage?.querySelector?.('product-form') ?? null);

		// Always place below ATC / Qty (never above)
		const host =
			productForm?.querySelector('[data-js-product-form-alert-host]') ||
			productPage?.querySelector('[data-js-product-form-alert-host]');
		if (host) {
			host.innerHTML = '';
			host.hidden = false;
			host.removeAttribute('hidden');
			host.appendChild(alertEl);
			alertEl.id = 'product-page-form-error-cart-alert';
			alertEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
			return;
		}
		const cartFunctions = productForm?.querySelector('.product__cart-functions');
		if (cartFunctions) {
			cartFunctions.appendChild(alertEl);
			alertEl.id = 'product-page-form-error-cart-alert';
			alertEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
			return;
		}

		const hostEl = productForm || container;
		alertEl.id = 'product-page-form-error-cart-alert';
		hostEl.appendChild(alertEl);
		alertEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
	};

	window.__krownShowProductQtyLimitAlert = function (container, productId, itemEl, options) {
		options = options || {};
		let message = options.message || '';
		const isGiftCard =
			window.__krownIsGiftCardProductPage(container) ||
			window.__krownIsGiftCardCartItem(itemEl);

		// Gift cards: never use availability_limit / "of this item are available"
		if (!message && isGiftCard) {
			message = window.__krownGetProductQtyLimitMessage(productId);
		}

		const isProductCard =
			options.isProductCard === true || window.__krownIsProductCardContext(container);
		if (!message && options.scenario) {
			message = window.__krownResolveStockMessage(options.scenario, {
				ruleMax: options.ruleMax ?? window.__krownGetProductQtyLimit(productId),
				stockLimit: options.inventoryQuantity ?? options.stockLimit,
				isProductCard,
			});
		}
		if (!message && options.qtyAdded != null) {
			const stockLimit =
				options.inventoryQuantity ??
				options.stockLimit ??
				window.__krownGetAvailabilityStockLimit?.(container);
			const ruleMax = options.ruleMax ?? window.__krownGetProductQtyLimit(productId);
			if (stockLimit != null || ruleMax != null) {
				message = window.__krownResolveStockMessage('partial_add', {
					ruleMax,
					stockLimit,
					isProductCard,
				});
			} else if (isProductCard) {
				message = window.__krownGetAvailabilityAddedMessage(options.qtyAdded);
			} else {
				// Prefer cap context over raw qtyAdded (which can be remaining/0)
				const cap = window.__krownGetCapTotal(ruleMax, stockLimit);
				message = window.__krownGetAvailabilityCanAddMessage(
					cap != null ? { ruleMax, stockLimit } : options.qtyAdded
				);
			}
		}
		if (!message && isProductCard) {
			const stockLimit =
				options.stockLimit ?? window.__krownGetAvailabilityStockLimit?.(container);
			const ruleMax = options.ruleMax ?? window.__krownGetProductQtyLimit(productId);
			message = window.__krownResolveStockMessage('cart_at_cap', {
				ruleMax,
				stockLimit,
				isProductCard: true,
			});
		}
		if (!message) {
			message = window.__krownGetProductQtyLimitMessage(productId);
		}
		if (!message) return;

		// Cart line: one notice under that item only — never a global form banner
		if (itemEl) {
			window.__krownClearCartFormQtyLimitBanners?.(itemEl);
			itemEl.querySelectorAll('.cart-item__qty-limit-notice').forEach((el) => el.remove());
			const inline = window.__krownCreateQtyLimitAlert(message);
			inline.classList.add('cart-item__qty-limit-notice', 'text-size--small');
			// Prefer a dedicated slot under the line; fall back to end of the cart item
			const host =
				itemEl.querySelector('[data-js-cart-item-qty-limit-host]') ||
				itemEl;
			host.appendChild(inline);
			return;
		}

		if (container) {
			window.__krownClearProductQtyLimitAlert(container);
			const alert = window.__krownCreateQtyLimitAlert(message);
			if (options.id) {
				alert.id = options.id;
			}
			window.__krownPlaceProductPageAlert(container, alert);
		}
	};

	window.__krownGetSiblingProductQtyInForm = function (form, productId, excludeItemKey) {
		let total = 0;
		if (!form || !productId) return total;
		form.querySelectorAll('[data-js-cart-item]').forEach((el) => {
			if (String(el.dataset.productId) !== String(productId)) return;
			if (excludeItemKey && el.dataset.id === excludeItemKey) return;
			const q = parseInt(el.querySelector('.qty')?.value || el.dataset.qty, 10);
			if (Number.isFinite(q)) total += q;
		});
		return total;
	};

	window.__krownGetMaxQtyForCartLine = function (form, item) {
		let max = null;

		const hardLimit = window.__krownGetProductQtyLimit(item?.dataset?.productId);
		if (hardLimit != null) {
			const otherQty = window.__krownGetSiblingProductQtyInForm(
				form,
				item.dataset.productId,
				item.dataset.id
			);
			max = Math.max(0, hardLimit - otherQty);
		}

		const invMax = window.__krownGetMaxQtyForCartLineInventory(form, item);
		if (invMax != null) {
			max = max == null ? invMax : Math.min(max, invMax);
		}

		return max;
	};

	window.__krownClampCartItemQty = function (form, item, qty) {
		if (qty === 0) return qty;
		const maxForLine = window.__krownGetMaxQtyForCartLine(form, item);
		if (maxForLine == null) return qty;
		if (maxForLine <= 0) {
			return parseInt(item.dataset.qty, 10) || parseInt(item.querySelector('.qty')?.value, 10) || 1;
		}
		return Math.min(Math.max(0, qty), maxForLine);
	};

	window.__krownRefreshProductQtyLimitsInForm = function (form) {
		if (!form) return;
		form.querySelectorAll('[data-js-cart-item]').forEach((item) => {
			if (item.classList.contains('cart-item--freebie')) return;
			const qtyInput = item.querySelector('.qty');
			if (!qtyInput) return;
			window.__krownApplyProductQtyLimitToInput(form, item, qtyInput);
		});
	};

	window.__krownApplyProductQtyLimitToInput = function (form, item, qtyInput) {
		if (!qtyInput) return;
		const maxForLine = window.__krownGetMaxQtyForCartLine(form, item);
		if (maxForLine == null) return;
		if (maxForLine > 0) {
			qtyInput.setAttribute('max', String(maxForLine));
			const current = parseInt(qtyInput.value, 10);
			if (Number.isFinite(current) && current > maxForLine) {
				qtyInput.value = maxForLine;
			}
		} else {
			qtyInput.setAttribute('max', '0');
		}
	};

	window.__krownGetCartLineLimitMessage = function (form, item) {
		const ctx = window.__krownGetCartLineCapContext?.(form, item) || {};
		const productId = ctx.productId || item?.dataset?.productId;
		const hardLimit = window.__krownGetProductQtyLimit(productId);
		// GC / hard-limit products: never availability copy
		if (ctx.isGiftCard || hardLimit != null) {
			return (
				window.__krownGetProductQtyLimitMessage(productId) ||
				'You can only add up to 20 of this item to your cart.'
			);
		}
		if (ctx.stockLimit != null || ctx.ruleMax != null) {
			return window.__krownResolveStockMessage('cart_at_cap', {
				ruleMax: ctx.ruleMax,
				stockLimit: ctx.stockLimit,
			});
		}
		return window.__krownGetProductQtyLimitMessage(productId);
	};

	window.__krownShowCartLineLimitAlert = function (form, item) {
		if (!item) return;
		const message = window.__krownGetCartLineLimitMessage(form, item);
		if (!message) return;
		// Always under the line — never form/global banner
		window.__krownShowProductQtyLimitAlert(form, item?.dataset?.productId, item, { message });
	};

	window.__krownGetMaxAddableQtyOnProductPage = async function (productPage, productId, variantId, requestedQty) {
		const requested = parseInt(requestedQty, 10) || 1;
		let maxAddable = requested;

		const hardLimit = window.__krownGetProductQtyLimit(productId);
		if (hardLimit != null) {
			const cartProductQty = await window.__krownFetchCartQtyForProduct(productId);
			maxAddable = Math.min(maxAddable, Math.max(0, hardLimit - cartProductQty));
		}

		const stockLimit = window.__krownGetAvailabilityStockLimit(productPage);
		if (stockLimit != null && variantId) {
			const cartVariantQty = await window.__krownFetchCartQtyForVariant(variantId);
			maxAddable = Math.min(maxAddable, Math.max(0, stockLimit - cartVariantQty));
		}

		return maxAddable;
	};
})();
